import { ComputedRef } from 'vue'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { RecentJudgeListViewModel } from '@/presentation/viewmodels/judge/recentJudgeListViewModel'

export class RecentJudgeListPresenter {
  private viewModel: RecentJudgeListViewModel

  constructor(viewModel: RecentJudgeListViewModel) {
    this.viewModel = viewModel
  }

  get recentJudgeList(): ComputedRef<JudgeRecord[]> {
    return this.viewModel.recentJudgeList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getRecentJudgeResultList(): Promise<void> {
    await this.viewModel.getRecentJudgeResultList()
  }
}
